<template>
  <p class="text-xs-center" v-if="error">Podany link aktywacyjny nie istnieje.</p>
  <v-container v-else fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Aktywacja konta</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="confirmTrainer" novalidate>
            <v-card-text>
            <Fields
              v-bind="{fields, object: formData, errors: formErrors}"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">Aktywuj konto</v-btn>
            </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {accountTrainerAdminConfirmEmail} from './api'
import iziToast from 'izitoast'
import * as types from '@/store/mutation-types'
import Fields from '@/forms/Fields'

export default {
  components: {Fields},
  validators: {
  },
  data () {
    return {
      progress: false,
      formErrors: {},
      formData: {
        key: this.$route.params.token
      },
      error: false
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    fields () {
      return [
        {comp: 'text', id: 'password1', label: 'Hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'password2', label: 'Powtórz hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin', props: {}}
      ]
    }
  },
  methods: {
    confirmTrainer () {
      this.$validate().then(success => {
        if (success) {
          this.progress = true
          accountTrainerAdminConfirmEmail(this.formData).then((data) => {
            iziToast.show({
              message: 'Konto zostało aktywowane',
              color: 'green'
            })
            this.$store.dispatch(types.AUTH_TOKEN, data.token).then(() => {
              this.$router.push({name: 'app'})
            })
            return data
          }).catch((data) => {
            if (data.response.status === 404) {
              this.error = true
            }
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          }).finally(() => {
            this.progress = false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/AccountTrainerAdminConfirmEmail.vue